<app-cross-sell style="overflow: auto;" 
    title={{title}}
    description={{description}}
    callToAction={{callToAction}}
    imageSource={{imageSource}}
    resellerId={{resellerId}}>
</app-cross-sell>